import { RingProgress } from "@mantine/core"
import { IconPlayerPauseFilled, IconPlayerPlayFilled } from "@tabler/icons-react"

import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * The round play/pause control. While the iOS-playable audio is still being
 * prepared (the AAC transcode warming up), the button is locked and a radial
 * progress ring wraps it so the wait reads as "almost ready" rather than broken.
 * Pure presentation — the smart Player owns the readiness state and the toast.
 */
export const PlayButton = ({
  isPlaying,
  size = "md",
  disabled,
  preparing,
  prepProgress,
  onToggle,
  playLabel,
  pauseLabel,
}: IProps): React.JSX.Element => {
  const pct = Math.max(0, Math.min(100, Math.round(prepProgress * 100)))
  const iconSize = size === "sm" ? 15 : 20

  return (
    <div className={classes.wrap} data-size={size}>
      {preparing && (
        <RingProgress
          className={classes.ring}
          size={size === "sm" ? 44 : 56}
          thickness={3}
          roundCaps
          sections={[{ value: pct, color: "brand" }]}
        />
      )}
      <button
        type="button"
        className={classes.playBtn}
        onClick={onToggle}
        aria-label={isPlaying ? pauseLabel : playLabel}
        disabled={disabled}
        data-preparing={preparing || undefined}
      >
        {isPlaying ? <IconPlayerPauseFilled size={iconSize} /> : <IconPlayerPlayFilled size={iconSize} />}
      </button>
    </div>
  )
}
